type GetSplitProfileInitialValuesProps = {
	applicationSplitProfileId?: string;
	receivedSplitProfile?: string;
	highRiskSplitProfile?: string;
	isHighRisk?: boolean;
	isMultipleHighRiskSplitProfiles?: boolean;
};

export const getSplitProfileInitialValues = ({
	applicationSplitProfileId,
	receivedSplitProfile,
	highRiskSplitProfile,
	isHighRisk,
	isMultipleHighRiskSplitProfiles,
}: GetSplitProfileInitialValuesProps) => {
	if (receivedSplitProfile === undefined) {
		if (isHighRisk === undefined) {
			return applicationSplitProfileId || "";
		} else {
			if (!isHighRisk) {
				return "";
			}
			if (isMultipleHighRiskSplitProfiles) {
				return applicationSplitProfileId || "";
			}
			return highRiskSplitProfile || "";
		}
	} else {
		return receivedSplitProfile;
	}
};
